import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../common/i18n/useTranslation';
import { WbText } from '@workbench/react';
import { Routes } from '../../routes/routes';
import BeamButton from '../../common/components/input/BeamButton';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles()((theme: Theme) => ({
    spacing: {
        marginBottom: theme.spacing(3),
        whiteSpace: 'pre-line',
    },
    buttonSpacing: {
        marginLeft: theme.spacing(1),
    },
}));

function RegistrationUncomplete() {
    const { classes } = useStyles();
    const navigate = useNavigate();
    const translate = useTranslation();
    return (
        <>
            <WbText size="m" className={classes.spacing}>
                <FormattedMessage id="registration_success" defaultMessage={'registration_success'} />
            </WbText>
            <BeamButton variant="primary" size="s" onClick={() => navigate(Routes.company_registration)}>
                {translate('continue_reg')}
            </BeamButton>
        </>
    );
}

export default RegistrationUncomplete;
